/** Merge tags for eISF signature-request emails (dbo.EISFConfig). */

export const EISF_SIGNATURE_REQUEST_EMAIL_MERGE_TAGS = [
  { tag: "{{StaffName}}", entityName: "StaffName", description: "Signer display name" },
  { tag: "{{DocumentTitle}}", entityName: "DocumentTitle", description: "Uploaded file name" },
  { tag: "{{DocumentCode}}", entityName: "DocumentCode", description: "Document code (if set)" },
  { tag: "{{StudyName}}", entityName: "StudyName", description: "Study name" },
  { tag: "{{SiteName}}", entityName: "SiteName", description: "Site name" },
  {
    tag: "{{PlaceholderName}}",
    entityName: "PlaceholderName",
    description: "Placeholder that required the signature",
  },
  {
    tag: "{{UploadedByName}}",
    entityName: "UploadedByName",
    description: "Staff who uploaded the document",
  },
  {
    tag: "{{DocumentOpenLink}}",
    entityName: "DocumentOpenLink",
    description: "Open document button — use this only (do not build your own link)",
  },
  { tag: "{{DocumentId}}", entityName: "DocumentId", description: "Document unique id" },
  {
    tag: "{{OrganizationName}}",
    entityName: "OrganizationName",
    description: "Organisation display name",
  },
];

export const EISF_SIGNATURE_REQUEST_EMAIL_DEFAULTS = {
  subject: "Signature required - {{DocumentTitle}}",
  body:
    "<p>Hello {{StaffName}},</p>" +
    "<p>{{UploadedByName}} has uploaded a document that requires your signature:</p>" +
    "<p><strong>{{DocumentTitle}}</strong></p>" +
    "<p>Study: {{StudyName}}<br />Site: {{SiteName}}<br />Placeholder: {{PlaceholderName}}</p>" +
    "<p>{{DocumentOpenLink}}</p>" +
    "<p>Regards,<br />{{OrganizationName}}</p>",
};
